import * as THREE from 'three'
import React, { useMemo } from 'react'

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { delModel, extrudeSettings, jTrimModel, wainscotTrimModel } from '../../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { MaterialWainScotTrimNew } from '../../../../../../CustomMaterial';

const TrimModel = () => {
    const textureObj = useMemo(() => {
        const texture = const_var.wallTextureObj?.[params.wallTexture]?.clone();
        const metalTexture = const_var.wallTextureObj?.["vertical"]?.clone();
        const lightTexture = const_var.wallTextureObj?.["vertical_light"]?.clone();
        const wainscotTexture = const_var.wallTextureObj?.[params.wainscotTexture]?.clone();
        
        if(metalTexture){
            if (params.wallOrientation === "vertical") metalTexture.rotation = 0;
            else metalTexture.rotation = Math.PI/-2;
        }
        if(lightTexture) lightTexture.rotation = metalTexture.rotation;
        if(texture && const_var.selSidingOption === "metal") texture.rotation = metalTexture.rotation
        if(wainscotTexture && (params.wainscotTexture === "none" || params.wainscotTexture === "vertical")) wainscotTexture.rotation = metalTexture.rotation

        return {"texture":texture,"wainscotTexture" : wainscotTexture,"metalTexture":metalTexture,"lightTexture":lightTexture};
    }, [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);
    
    const wallThickness = 0.005;
    
    /**********************cutting hole using CSG Side************************/

    const jTrimSideModelObj = useMemo(() => {
        let main;
        let wainscot;

        const storageDelShape = new THREE.Shape();
        storageDelShape.moveTo(params.lean_p_d / 2 - 0.25, 0);
        storageDelShape.lineTo(params.lean_p_d / 2 - 0.25, params.lean_p_h);
        storageDelShape.lineTo(params.lean_p_d / 2 - parseInt(params.add_storage) - 0.27, params.lean_p_h)
        storageDelShape.lineTo(params.lean_p_d / 2 - parseInt(params.add_storage) - 0.27, 0);
        storageDelShape.closePath();
        
        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(parseInt(params.add_storage) + 0.2)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('leftLeanSide', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageDelShape, extrudeSettings(0.4)))
    
        const meshJTrimCutModel_Temp = meshStorageDelModel.clone();
        meshJTrimCutModel_Temp.position.set(0.25, 0, -0.1)
        meshJTrimCutModel_Temp.updateMatrixWorld();
        
        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.position.set(-(params.lean_p_d / 2 + 0.15), 0.1, 0.0625)
        meshJTrimModel_Temp.rotation.y = Math.PI/2
        meshJTrimModel_Temp.updateMatrixWorld()
    
        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(params.lean_p_pos + params.leftLeanStoragePosition, 0, -0.5);
        meshDelModel_Temp.updateMatrixWorld()
        
        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
    
        const meshJTrimCutModel_CSG = CSG.fromMesh(meshJTrimCutModel_Temp)
        
        const JTrimModel_CSG_Temp = meshJTrimModel_CSG.subtract(meshDelModel_CSG);
    
        let JTrimModel_CSG;

        if(params.add_storage_check) {
            JTrimModel_CSG = JTrimModel_CSG_Temp.subtract(meshJTrimCutModel_CSG)
        } else {
            JTrimModel_CSG = JTrimModel_CSG_Temp
        }
    
        const CSGJTrimModel = CSG.toMesh(JTrimModel_CSG,new THREE.Matrix4())

        main =CSGJTrimModel.geometry

        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(parseInt(params.add_storage) + 0.02)), new THREE.MeshStandardMaterial({color: 'red'}))

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.position.set(params.lean_p_d / 2 - parseInt(params.add_storage) - 0.02, 3 , 0.06)
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/2
        meshWainscotTrimModel_Temp.updateMatrixWorld()

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);

        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGWainscotTrimModel = CSG.toMesh(WainscotTrimModel_CSG,new THREE.Matrix4())

        wainscot = CSGWainscotTrimModel.geometry

        return {main, wainscot}
    }, [params.lean_p_d, params.lean_p_pos, params.add_left_front_lean_porch, params.leftLeanStoragePosition, params.add_left_back_lean_porch, params.p_b_c_b_l, params.add_storage_check, params.add_storage, params.lean_p_h, const_var.newDoorsArray])

    /****************************************************************/

    return (
        <group  position={[-(params.p_w / 2 + params.lean_p_w + 0.05 + wallThickness), 0, 0]} rotation={[0, Math.PI / 2, 0]}>
            {params.p_w_c_n == true &&
                <mesh name="wainscotTrim" geometry={jTrimSideModelObj.wainscot} >
                    <MaterialWainScotTrimNew   visibleSection={"leftlean"}/>
                </mesh>
            }
        </group>
    )
}

export default TrimModel